import { type StoryblokProductSearchFilterNoveltiesType } from '../../../../storyblok'
import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

import { storyblokProductSearchFiltersGetValuesFromString } from './storyblokProductSearchFiltersGetValuesFromString'

// 24 * 60 * 60 * 1000
const DAY_IN_MILLIS = 86_400_000
const DEFAULT_NOVELTIES_DAYS = 60

export const storyblokProductSearchFiltersGetNovelties = (
  noveltiesFilters: StoryblokProductSearchFilterNoveltiesType,
): Partial<
  Pick<
    StoryblokProductSearchFiltersType,
    'categoryCodes' | 'created' | 'prescriptionMedicine'
  >
> => {
  const { categoryIds, period } = noveltiesFilters

  const parsedPeriod = Number.isFinite(Number(period))
    ? Number(period)
    : DEFAULT_NOVELTIES_DAYS

  const daysInMilliseconds = parsedPeriod * DAY_IN_MILLIS

  return {
    categoryCodes:
      storyblokProductSearchFiltersGetValuesFromString(categoryIds),
    created: {
      min: new Date(Date.now() - daysInMilliseconds).getTime(),
    },
    prescriptionMedicine: false,
  }
}
